import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { router } from 'expo-router';

import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import {
  BOOKING_STATUS_COPY,
  BOOKING_STATUS_TONE,
} from '@/constants/booking-status';
import { BOOKING_STATUS } from '@/types/service';

interface Props {
  status?: BOOKING_STATUS | null;
  /** Esconde o banner quando já está tudo certo (padrão: mostra). */
  hideWhenBookable?: boolean;
}

/**
 * Diz ao prestador, dentro da tela do serviço, por que ele ainda não é
 * agendável e para onde ir. Substitui o silêncio de "configurei e nada
 * aconteceu".
 */
export function BookingStatusBanner({ status, hideWhenBookable }: Props) {
  if (!status) return null;
  if (hideWhenBookable && status === BOOKING_STATUS.BOOKABLE) return null;

  const copy = BOOKING_STATUS_COPY[status];
  const tone = BOOKING_STATUS_TONE[copy.tone];

  return (
    <View
      className="gap-2 rounded-2xl p-4"
      style={{ backgroundColor: tone.background, borderCurve: 'continuous' }}
    >
      <View className="flex-row items-center gap-2">
        <Ionicons name={copy.icon} size={17} color={tone.foreground} />
        <ThemedText
          className="flex-1 text-sm font-bold"
          style={{ color: tone.foreground }}
        >
          {copy.label}
        </ThemedText>
      </View>
      <ThemedText
        className="text-xs leading-4"
        style={{ color: tone.foreground }}
      >
        {copy.hint}
      </ThemedText>

      {copy.action ? (
        <PressableScale
          haptic
          accessibilityRole="button"
          onPress={() => router.push(copy.action!.href as never)}
          className="mt-1 self-start rounded-full bg-card px-4 py-2"
          style={{ borderCurve: 'continuous' }}
        >
          <ThemedText
            className="text-xs font-bold"
            style={{ color: tone.foreground }}
          >
            {copy.action.label}
          </ThemedText>
        </PressableScale>
      ) : null}
    </View>
  );
}
